import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
export var propertyHistory = /*#__PURE__*/css("background-color:", tokens.colors.neutral.surface.default, ";overflow-anchor:none;");